export type AssetKind = 'fonts' | 'logos';

export const isProjectOwnedAssetUrl = (
  assetUrl: string,
  projectId: string | undefined,
  kind: AssetKind
): boolean => {
  if (!projectId) return false;
  if (!assetUrl) return false;

  try {
    const pathname: string = new URL(assetUrl, window.location.origin).pathname;
    return pathname.startsWith(`/users/${projectId}/${kind}/`);
  } catch {
    return false;
  }
};

export const isInaccessibleUserAssetUrl = (
  assetUrl: string,
  accessibleProjectIds: Set<string> | undefined,
  kind: AssetKind
): boolean => {
  if (!assetUrl || !accessibleProjectIds) return false;

  try {
    const parsedUrl = new URL(assetUrl, window.location.origin);
    if (parsedUrl.origin !== window.location.origin) return false;

    const pathname: string = parsedUrl.pathname;
    if (!pathname.startsWith('/users/')) return false;

    const [, , assetProjectId, assetKind] = pathname.split('/');
    return assetKind === kind && !accessibleProjectIds.has(assetProjectId);
  } catch {
    return false;
  }
};

export const isUserUploadedAssetUrl = (
  assetUrl: string,
  kind: AssetKind
): boolean => {
  if (!assetUrl) return false;

  try {
    const pathname: string = new URL(assetUrl, window.location.origin).pathname;
    const pathParts: string[] = pathname.split('/').filter(Boolean);
    return pathParts.length >= 4 && pathParts[0] === 'users' && pathParts[2] === kind;
  } catch {
    return false;
  }
};
